export const SET_BOOKING = 'SET_BOOKING';

export const FETCH_BOOKING = 'FETCH_BOOKING';
